import { ToastUtility } from "@syncfusion/ej2-react-notifications";

const showSuccessAppToaster = (content: string, title: string = "Success!") => {
  ToastUtility.show({
    title: title,
    content,
    cssClass: "success",
    position: { X: "Center", Y: "Top" },
    showCloseButton: true,
    timeOut: 10000,
  });
};

const showDownloadingFileAppToaster = (
  fileName: string,
  title: string = "Exporting..."
) => {
  ToastUtility.show({
    title: title,
    content: `${fileName} is downloading...`,
    position: { X: "Center", Y: "Top" },
    showCloseButton: true,
  });
};

const showFailedActionToaster = (content: string, title: string = "Error") => {
  ToastUtility.show({
    title: title,
    content,
    cssClass: "failed",
    position: { X: "Center", Y: "Top" },
    showCloseButton: true,
  });
};

export default {
  showSuccessAppToaster,
  showDownloadingFileAppToaster,
  showFailedActionToaster,
};
